<template>
  <!-- <div
    id="seasidetms_row_l4py6s2xk"
    class="seasidetms_row seasidetms_color_scheme_default seasidetms_row_top_default seasidetms_row_bot_default seasidetms_row_boxed"
  >
    <div class="seasidetms_row_outer_parent">
      <div class="seasidetms_row_outer">
        <div class="seasidetms_row_inner">
          <div
            class="seasidetms_row_margin seasidetms_row_columns_behavior seasidetms_11"
          > -->
            <div
              id="seasidetms_column_f26rc0o9rs"
              class="seasidetms_column one_first"
            >
            <div class="h3 edgtf-st-title text-center">
                        <span style="color: #29292a;">{{$t('equipment.title')}}</span>
                      </div>
              <div class="seasidetms_column_inner">
                <div
                  id="seasidetms_fb_czot0nn2x"
                  class="seasidetms_featured_block"
                >
                  <div class="featured_block_inner">
                    <div class="featured_block_text">
                      <p id="cmsms_heading_5757ce4780801" class="cmsms_heading">
                        <!-- <span style="color: #29292a;"
                          >Duis interdum risus ligula, in consequat lectus
                          eleifend quis. In malesuada finibus arcu eu volutpat.
                          Suspendisse ornare lacus ligula, quis mollis augue
                          accumsan et. Phasellus et ante id ante finibus
                          consectetur at ut lorem. Etiam id facilisis lorem.
                          Aliquam eleifend orci ligula, sit amet posuere lectus
                          egestas vitae. Morbi et felis vestibulum, euismod
                          magna in, tempor enim. Vivamus placerat dictum enim
                          eget pellentesque. Mauris egestas cursus
                          malesuada.</span
                        > -->
                        <ul style="color: #29292a;">
                          <li v-html="$t('equipment.1')"></li>
                          <li v-html="$t('equipment.2')"></li>
                          <li v-html="$t('equipment.3')"></li>
                        </ul>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <p class="paragraph-text mt-20" v-html="$t('equipment.attention')">
              </p>
            </div>
          <!-- </div>
        </div>
      </div>
    </div>
  </div> -->
</template>

<script>
export default {
  name: 'Equipment',
}
</script>

<style>
#seasidetms_fb_czot0nn2x {
  padding-top: 0px;
  padding-bottom: 0px;
  -webkit-border-radius: 5px;
  border-radius: 5px;
  background-color: #dddddd;
  background-image: url(/img/equipment.jpg);
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: scroll;
  background-size: cover;
}

#seasidetms_fb_czot0nn2x .featured_block_inner {
  width: 37%;
  padding: 4% 40px 3% 5%;
  text-align: left;
  float: left;
  background-color: rgba(255, 255, 255, 0.95);
}

#seasidetms_fb_czot0nn2x .featured_block_text {
  text-align: left;
}
</style>
